/*Generated from the `:::slide{key="37ead7d7-49a0-44bb-9780-eda8eca32cac" slug="level-1/after-厅/multi-component-decomposition"}` (simplified/018/003/厅.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, SlideTitle, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!SlideTitle) _missingMdxReference("SlideTitle", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.a) _missingMdxReference("html.a", true);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "SlideTitle",
      count: "4",
      children: _jsx(SlideTitle, {
        children: "More Than Two Parts",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["Most characters you've seen so far split into two pieces. Some take ", _jsx(html.strong, {
          children: "more than two",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsxs(html.p, {
        children: ["The next character, 岸, is ", _jsx(html.a, {
          href: "%E5%B1%B1",
          children: _jsx(html.em, {
            children: "mountain",
            components: html
          }),
          components: html
        }), " + ", _jsx(html.a, {
          href: "%E5%8E%82",
          children: _jsx(html.em, {
            children: "cliff",
            components: html
          }),
          components: html
        }), " + ", _jsx(html.a, {
          href: "%E5%B9%B2",
          children: _jsx(html.em, {
            children: "dry",
            components: html
          }),
          components: html
        }), " — three components, not a pair."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "p",
      count: "4",
      children: _jsx(html.p, {
        children: "When a card lists several parts, read them in order. The mnemonic still works the same way; there are just more pieces in the picture.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
